import {
  GOTO_SECTION,
  TOGGLE_SIDEBAR,
  DISPLAY_MAIN_HEADER,
  DISPLAY_LOADER,
  DISPLAY_FETCHING_LOADER,
  DISPLAY_GQ_LOADER,
} from '../../constants/types'


export const navGoToSection = (section) => ({
  type: GOTO_SECTION,
  payload: section,
})

export const navToggleSidebar = () => ({
  type: TOGGLE_SIDEBAR,
  payload: 1,
})

export const displayMainHeader = (display) => ({
  type: DISPLAY_MAIN_HEADER,
  payload: display,
})

export const displayLoader = (isLoading) => ({
  type: DISPLAY_LOADER,
  payload: isLoading,
})

export const displayFetchingLoader = (isFetching) => ({
  type: DISPLAY_FETCHING_LOADER,
  payload: isFetching,
})

export const displayGQLoader = (isLoading) => ({
  type: DISPLAY_GQ_LOADER,
  payload: isLoading,
})
